import initDragButtons from './components/payment-method-drag'

initDragButtons()
